import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Input, Modal } from "ui";

import { useCancelOrder } from "../../../apis";
import { cancelOrderFormSchema } from "../../../helpers";
import { CancelOrderFormValues } from "../../../orders.types";
import { CancelOrderModalProps } from "./CancelOrderModal.types";

import styles from "./CancelOrderModal.module.scss";

const CANCEL_ORDER_FORM_ID = "REJECT_RETURN_FORM_ID";

const CancelOrderModal = ({
  orderId,
  isOpen,
  onClose,
  refetchDetails,
  refetchList
}: CancelOrderModalProps) => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState } = useForm<CancelOrderFormValues>({
    defaultValues: {
      orderId,
      cancellationReason: ""
    },
    resolver: yupResolver(cancelOrderFormSchema)
  });

  const cancelOrder = useCancelOrder({
    onSuccess: () => {
      toast.success("Order has been successfully canceled");

      refetchDetails?.();
      refetchList();
      onClose();
    }
  });

  const submitOrderCancellation = (values: CancelOrderFormValues) => {
    cancelOrder.mutate(values);
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t("Cancel Order")}
      formId={CANCEL_ORDER_FORM_ID}
      okText="Confirm"
      contentClassName={styles.cancelOrderModal}
      onClose={onClose}
    >
      <p className={styles.cancelOrderModal_text}>
        {t("Describe the reason for order cancellation")}
      </p>

      <form
        id={CANCEL_ORDER_FORM_ID}
        onSubmit={handleSubmit(submitOrderCancellation)}
      >
        <Input
          asTag="textarea"
          placeholder={t("Message")}
          errorMessage={formState.errors.cancellationReason?.message}
          {...register("cancellationReason")}
        />
      </form>
    </Modal>
  );
};

export default CancelOrderModal;
